import {Box} from '@dropbox/dig-foundations';

export enum RedactedMetricValuePlaceholderWidth {
  Normal = 'normal',
  Short = 'short',
}

const REDACTED_METRIC_VALUE_PLACEHOLDER_WIDTHS: Record<
  RedactedMetricValuePlaceholderWidth,
  number
> = {
  [RedactedMetricValuePlaceholderWidth.Normal]: 48,
  [RedactedMetricValuePlaceholderWidth.Short]: 12,
};

/**
 * Non-interactive visual treatment for a metric value the viewer is not authorized to read.
 *
 * Keep this distinct from loading skeletons: it represents an intentionally withheld value.
 */
export const RedactedMetricValuePlaceholder = ({
  centerHorizontally = false,
  width = RedactedMetricValuePlaceholderWidth.Normal,
}: {
  centerHorizontally?: boolean;
  width?: RedactedMetricValuePlaceholderWidth;
}) => (
  <Box
    aria-hidden
    style={{
      width: REDACTED_METRIC_VALUE_PLACEHOLDER_WIDTHS[width],
      height: 8,
      marginTop: 4,
      ...(centerHorizontally ? {marginLeft: 'auto', marginRight: 'auto'} : {}),
      borderRadius: 'var(--dig-radius__small)',
      background: 'var(--dig-color__border__subtle)',
      filter: 'blur(4px)',
    }}
  />
);
